import styled from 'styled-components'

export const Container = styled.div``

export const InlineForm = styled.div`
  display: inline-flex;
`

export const FormGroup = styled.div.attrs({
  className: 'form-group mr-5'
})`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ErrorSummary = styled.p`
  color: red;
  font-weight: bold;
  font-size: 12px;
`

export const Form = styled.form`
  display: inline-flex;
  margin-top: 40px;
`

export const DateInput = styled.input`
  background: rgba(246, 246, 246, 0.6);
  border: 0;
  border-bottom: 3px solid #002d62;
  width: 160px;
`

export const Select = styled.select`
  width: 240px;
`

export const SearchButton = styled.button`
  height: 40px;
`

export const TableContainer = styled.div.attrs({
  className: 'table-responsive mt-5'
})`
  overflow-y: auto;
  height: 400px;
`

export const Table = styled.table.attrs({
  className: '-striped -highlight'
})`
  font-size: 0.7em;
  width: 100%;
  max-width: 100%;
  height: 100%;
`

export const Loading = styled.progress`
  opacity: 0.6;
`
